// extracted by mini-css-extract-plugin
export default {"dd-m-whatsapp":"cart_button_dd-m-whatsapp__HmnC1","icon":"cart_button_icon__xuMPY"};